// 设备管理
export default [{ // 设备管理
  path: '/deviceManager',
  name: 'deviceManager',
  component: resolve => require(['@/views/device/deviceManager.vue'], resolve),
  meta: {
    group: "/deviceManager",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 添加设备
  path: '/addDevice',
  name: 'addDevice',
  component: resolve => require(['@/views/device/addDevice.vue'], resolve),
  meta: {
    group: "/deviceManager",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 编辑设备
  path: '/editDevice',
  name: 'editDevice',
  component: resolve => require(['@/views/device/addDevice.vue'], resolve),
  meta: {
    group: "/deviceManager",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 设备激活
  path: '/deviceActivation',
  name: 'deviceActivation',
  component: resolve => require(['@/views/device/deviceActivation.vue'], resolve),
  meta: {
    group: "/deviceActivation",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 激活设备
  path: '/activationDevice',
  name: 'activationDevice',
  component: resolve => require(['@/views/device/activationDevice.vue'], resolve),
  meta: {
    group: "/deviceActivation",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 运行记录
  path: '/deviceOpsRecord',
  name: 'deviceOpsRecord',
  component: resolve => require(['@/views/device/deviceOpsRecord.vue'], resolve),
  meta: {
    group: "/deviceOpsRecord",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}] 


// WEBPACK FOOTER //
// ./src/router/device/device.js